import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'

import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import { IntlProvider, addLocaleData } from 'react-intl'
import cs from 'react-intl/locale-data/cs'

import App from './containers/App'
import configureStore, { history } from './redux'
import createSagaManager from './sagas'

import { cs as csMessages } from './i18n'
import createLog from './utils/createLog'

const locale = 'cs'
addLocaleData(cs)

const messages = {
  cs: csMessages,
}

// Catch errors which are not catched by any other mechanism
window.addEventListener(
  'error',
  event => {
    // Prevent duplicit error processing
    if (event.error.stack && event.error.stack.indexOf('invokeGuardedCallbackDev') >= 0) {
      return true
    }
    createLog({ error: event.error })

    return false
  },
  false
)

const store = configureStore()
// Start all sagas with the API configured according to the environment
createSagaManager(store).start()

export const render = (Component: any) => {
  ReactDOM.render(
    <Provider store={store}>
      <div className="rs">
        <IntlProvider key={locale} locale={locale} messages={messages[locale]}>
          <ConnectedRouter history={history}>
            <Component />
          </ConnectedRouter>
        </IntlProvider>
      </div>
    </Provider>,
    document.getElementById('root')
  )
}

render(App)

// istanbul ignore next
// @ts-ignore
if (module.hot) {
  // React HMR
  // @ts-ignore
  module.hot.accept('./containers/App', () => {
    render(App)
  })

  // Reducer HMR
  // @ts-ignore
  module.hot.accept('./redux', () => {
    const nextReducer = require('./redux').reducer
    store.replaceReducer(nextReducer)
  })

  // Saga HMR, note that when enabled, changes in ./redux will also trigger the reload
  // @ts-ignore
  module.hot.accept('./sagas', () => {
    const nextSagaManager = require('./sagas').default(store)
    nextSagaManager.cancel()
    nextSagaManager.start()
  })
}
